module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/school-desk-double/school-desk-double.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/school-desk-double/school-desk-double.png
// module id = 622
// module chunks = 0